"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaults = {
  palette: {
    type: 'dark',
    primary: {
      main: '#0eb8ff',
      dark: '#004884',
      contrastText: '#fff'
    },
    secondary: {
      main: '#de2525'
    }
  },
  shape: {
    borderColor: 'rgba(255, 255, 255, 0.23)'
  },
  overrides: {},
  typography: {
    useNextVariants: true
  }
};
var _default = defaults;
exports["default"] = _default;